module.exports = __webpack_public_path__ + "img/mew.ad46b0ca.png";